<script context="module">
    export function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    export function getOuterHeight(element) {
        var elmHeight, elmMargin;
        if(document.all) {// IE
            elmHeight = element.currentStyle.height;
            elmMargin = parseInt(element.currentStyle.marginTop, 10) + parseInt(element.currentStyle.marginBottom, 10);
        } else {// Mozilla
            elmHeight = document.defaultView.getComputedStyle(element, '').getPropertyValue('height');
            elmMargin = parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-bottom'));
        }

        elmHeight = parseInt(elmHeight);
        elmMargin = parseInt(elmMargin);
        return Number(elmHeight+elmMargin);
    }

    export function getOuterWidth(element) {
        var elmWidth, elmMargin;
        if(document.all) {// IE
            elmWidth = element.currentStyle.width;
            elmMargin = parseInt(element.currentStyle.marginLeft, 10) + parseInt(element.currentStyle.marginRight, 10);
        } else {// Mozilla
            elmWidth = document.defaultView.getComputedStyle(element, '').getPropertyValue('width');
            elmMargin = parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-left')) + parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-right'));
        }

        elmWidth = parseInt(elmWidth);
        elmMargin = parseInt(elmMargin);
        return Number(elmWidth+elmMargin);
    }
</script>